import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FeedMedia } from 'shared/src/api/types'
import cx from 'classnames'
import { isImageFeedContent } from 'shared/src/api/types'
import { videoThumbnail } from 'shared/src/api/types'

const useStyles = createUseStyles({
  mediaContainer: {
    flex: 1,
    flexBasis: '50%',
    width: 166,
    maxWidth: 166,
    height: 230,
    maxHeight: 230,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mediaImage: {
    maxWidth: 144,
    maxHeight: 214,
    height: 'auto',
    position: 'absolute',
    zIndex: 1,
    paddingTop: 4,
  },
  productImage: {
    position: 'absolute',
    width: '100%',
    height: 'auto',
    maxWidth: 127,
    filter: 'brightness(0.3)',
    opacity: 0.9,
  },
  productImage0: {
    right: 8,
    bottom: 0,
  },
  productImage1: {
    left: 16,
    top: 0,
  },
  productImage2: {
    top: 24,
    left: 0,
  },
})

interface Props {
  media: FeedMedia
  className?: string
}

export const MediaProductStack: FC<Props> = flowMax(
  addDisplayName('MediaProductStack'),
  addProps(() => ({
    classes: useStyles(),
  })),
  addProps(({ classes }) => ({
    productClasses: [
      classes.productImage0,
      classes.productImage1,
      classes.productImage2,
    ],
  })),
  ({ media, productClasses, classes, className }) => (
    <div className={cx(className, classes.mediaContainer)}>
      {media.products
        .slice(Math.min(0, 3, media.products.length - 1))
        .map((product, productIndex) => (
          <img
            src={product.image.thumbnail}
            key={productIndex}
            className={cx(classes.productImage, productClasses[productIndex])}
            alt=""
          />
        ))}
      <img
        src={
          media.coverImage
            ? media.coverImage.thumbnail
            : isImageFeedContent(media.content)
            ? media.content.value.thumbnail
            : videoThumbnail(media.content)
        }
        className={classes.mediaImage}
        alt=""
      />
    </div>
  )
)
